export function validateRUT(rut?: string): boolean {
  if (!rut) {
    return false;
  }

  const cleanedRUT = rut.replace(/\./g, '').replace(/-/g, '');

  if (cleanedRUT.length < 2) {
    return false;
  }

  const numericPart = cleanedRUT.slice(0, -1);
  const checkDigit = cleanedRUT.slice(-1).toUpperCase();

  let sum = 0;
  let multiplier = 2;

  for (let i = numericPart.length - 1; i >= 0; i--) {
    sum += parseInt(numericPart[i], 10) * multiplier;
    multiplier = multiplier === 7 ? 2 : multiplier + 1;
  }

  const remainder = 11 - (sum % 11);
  const calculatedCheckDigit = remainder === 11 ? '0' : remainder === 10 ? 'K' : remainder.toString();

  return calculatedCheckDigit === checkDigit;
}

export function transformRUT(rut: string): string {
  if (!rut) {
    return '';
  }

  const cleanedRUT = rut.replace(/\./g, '').replace(/-/g, '');
  const numericPart = cleanedRUT.slice(0, -1);
  const checkDigit = cleanedRUT.slice(-1);

  const formattedNumericPart = numericPart
    .split('')
    .reverse()
    .reduce((acc, char, index) => {
      return index > 0 && index % 3 === 0 ? `${char}.${acc}` : `${char}${acc}`;
    }, '');

  return `${formattedNumericPart}-${checkDigit}`;
}